import { ValueTransformer } from "@angular/compiler/src/util";

export class VariableValue {
    value: any;
    asBoolean?: boolean;
    asString?: string;
}